<template>
  <div>
    <div class="mb-3">
      <FlatInput
        id="accessCodeInput"
        label="Enter access code"
        type="text"
        v-model="code"
        placeholder="Enter access code"
        :onEnter="handleSubmit"
        autocomplete="one-time-code"
      />
      <div v-if="error" class="text-danger small mt-1">{{ error }}</div>
    </div>

    <AppButton
      type="button"
      :disabled="loading || !code"
      :loading="loading"
      customClass="w-100"
      ignore-plan-restriction
      @buttonClick="handleSubmit"
    >
      Submit
    </AppButton>
  </div>
</template>

<script>
import FlatInput from "@/Components/FlatInput.vue";
import AppButton from "@/Components/AppButton.vue";

export default {
  name: "CodeUnlockForm",
  components: { FlatInput, AppButton },
  props: {
    linkId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      code: "",
      loading: false,
      error: "",
    };
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      if (!this.code) return;
      this.loading = true;
      try {
        // Unified unlock endpoint
        const url = typeof route === "function" && route().has("link.unlock")
          ? route("link.unlock")
          : "/link/unlock";

        const res = await axios.post(url, {
          link_id: this.linkId,
          step: 1,
          input: this.code,
        });

        const ok = !!(res && res.data && res.data.success === true);
        if (ok) {
          this.$emit("success", true);
        } else {
          this.error = "Invalid access code. Please try again.";
          this.$emit("success", false);
        }
      } catch (e) {
        console.error("unlock code request failed", e);
        this.error = "Unable to verify code right now. Please try again.";
        this.$emit("success", false);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
